import React  from 'react';
import styled from 'styled-components';
import { IconInstagram } from '../../Assets/contacts/IconInstagram';
import { IconPhone } from '../../Assets/contacts/IconPhone';
import { IconFacebook } from '../../Assets/contacts/IconFacebook';
import { IconYoutube } from '../../Assets/contacts/IconYoutube';
const Styles = styled.div`
  margin: 0 0 0.5rem 0;
  .over {
    width: calc(100% - calc(var(--universal-pad) * 2) - 4rem);
    margin: 0 var(--universal-pad);
    background-color: var(--n-grey-0);
    box-shadow: 0px 4px 50px -16px #00000028;
    padding: 1.25rem 2rem;
    border-radius: var(--border-radius-32);
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .base {
      display: flex;
      align-items: flex-end;
      gap: 0.2rem;
      .title1 {
        font-size: 1.5rem;
        font-weight: 700;
      }
      .title2 {
        font-size: 0.9rem;
        font-weight: 700;
      }
    }
    .image {
      position: absolute;
      top: -60px;
      left: calc(50% - 50px);
      width: 100px;
      height: 100px;
      background-color: #6ABBAB;
      border: 1px solid var(--n-grey-1);
      border-radius: 1000px;
      overflow: hidden;
      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .end {
      display: flex;
      justify-content: flex-end;
      gap: 1.25rem;
      .social {
        border-radius: 100px;
        border: 1px solid var(--n-grey-1);
        background-color: var(--n-grey-01);
        padding: 0.87rem;
        svg {
          display: block;
        }
      }
    }
  }
  @media screen and (max-width: 850px) {
    .over {
      flex-direction: column;
      gap: 1rem;
      .base {
        margin-top: 2rem;
      }
    }
  }
`
export default function AboutusMain10 (props){
  const {data: dataRaw} = props;
  const data = JSON.parse(dataRaw);
  const makeLink = (link, type) => {
    if(link){
      switch(type){
        case "instagram":
          return (
            <a className='social' href={link} target='_blank' rel="noreferrer">
              <IconInstagram/>
            </a>
          )
        case "facebook":
          return (
            <a className='social' href={link} target='_blank' rel="noreferrer">
              <IconFacebook/>
            </a>
          )
        case "youtube":
          return (
            <a className='social' href={link} target='_blank' rel="noreferrer">
              <IconYoutube/>
            </a>
          )
        case "tell":
          return (
            <a className='social' href={link} target='_blank' rel="noreferrer">
              <IconPhone/>
            </a>
          )
        default:
          return;
      }
    }
    return;
  }
  return (
    <Styles>
      <div className='over'>
        <div className='base'>
          <h1 className='title1'>
            {data.title1}
          </h1>
          <span className='title2'>
            ({data.title2})
          </span>
        </div>
        <div className='image'>
          <img src={data.Image} alt={data.title1}/>
        </div>
        <div className='end'>
          {makeLink(data.tell, "tell")}
          {makeLink(data.insta, "instagram")}
          {makeLink(data.facebook, "facebook")}
          {makeLink(data.youtube, "youtube")}
        </div>
      </div>
    </Styles>
  )
}

